// import React from 'react'

// const PaymentsFromQb = () => {
//   return (
//     <div>PaymentsFromQb</div>
//   )
// }

// export default PaymentsFromQb

import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
} from "../../../components";
import qbLoading from "../../../assets/qbLoading.svg";
import cloud_alert from "../../../assets/cloud_alert.svg";
import cloud_done from "../../../assets/cloud_done.svg";
import { dateFormator, formatNumber, mapTableRows } from "../../../utils";
import QbDocument from "../../../components/Module/Invoices/InvoiceModals/QbDocument";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { qbApiStart } from "../../../redux/slices/quickBooks/quickBooksSlice";
import { usePagination } from "../../../hooks";
import {
  getAccountPayablesStart,
  updateAccountPayablesStart,
} from "../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../redux/slices/totalCount/totalCountSlice";
import { WORKFORCE_API_URL } from "../../../redux/apiConfig";
import axios from "axios";
import QbAnimationLoading from "../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";

const APInvoicesFromQb = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [qbLoading, setQbLoading] = useState(false);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables
  );

  const { value } = useSelector((state) => state.totalCount);

  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );

  //const tablerowData = accountPayables;
  const tablerowData = accountPayables?.data || []; // Add null check with default empty array
  console.log("tablerowData", tablerowData);
  // Handle sort function
  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      // Toggle between 1 (ascending) and -1 (descending)
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };
  const [uploadQb, setUploadQb] = useState(false);
  const tableData = [
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "Entrans Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
    {
      client: "VDart Inc",
      invoiceNumber: "16500",
      paymentDate: "2025-04-20T18:30:00.000Z",
      referenceNumber: "--",
      receivedAmount: "10912.00 USD",
    },
  ];
  //design

  // const columns = [
  //   {
  //     key: "client",
  //     label: "Client",
  //     render: (row) => (
  //       <div className="cursor-pointer flex gap-2 items-center">
  //         <Avatar
  //           src={true ? cloud_done : cloud_alert}
  //           alt=""
  //           outline
  //           className="border-none"
  //           size="xs-sm"
  //         />
  //         {/* <Button type="icon" icon={false ? "cloud_alert": "cloud_done"} variant="text" color="black" /> */}
  //         {row.client}
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "invoiceNumber",
  //     label: "Invoice Number",
  //   },
  //   {
  //     key: "paymentDate",
  //     label: "Payment Date",
  //     render: (row) => dateFormator(row.paymentDate, "month-day-year"),
  //   },
  //   {
  //     key: "referenceNumber",
  //     label: "Reference Number",
  //   },
  //   {
  //     key: "receivedAmount",
  //     label: "Received Amount",
  //     render: (row) => <div>{formatNumber(row.receivedAmount)}</div>,
  //   },
  //   // {
  //   //   key: "Actions",
  //   //   label: "Actions",
  //   //   render: (row) => (
  //   // <div className="cursor-pointer">
  //   //   <Avatar
  //   //     src={qbLoading}
  //   //     alt=""
  //   //     outline
  //   //     className="border-none"
  //   //     size="xs"
  //   //   />
  //   // </div>
  //   //   ),
  //   // },
  // ];
  //for now
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <div className="cursor-pointer flex gap-2 items-center">
          <Avatar
            src={row.qbSync?.id ? cloud_done : cloud_alert}
            alt=""
            outline
            className="border-none"
            size="xs-sm"
            // size="xs"
            // size="sm"
          />
          {/* <Button type="icon" icon={false ? "cloud_alert": "cloud_done"} variant="text" color="black" /> */}
          {row.invoiceNumber}
        </div>
      ),
      sortable: false,
    },

    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "recordType",
      label: "Record Type",
      sortable: false,
    },
    {
      key: "vendor",
      label: "Vendor",
      sortable: false,
    },
    {
      key: "employees",
      label: "Employees",
      sortable: false,
    },
    {
      key: "invoicDate",
      label: "Invoice Date",
      sortable: false,
    },
    {
      key: "dueDate",
      label: "Due Date",
      sortable: false,
    },

    {
      key: "invoiceAmount",
      label: "Invoice Amount",
      sortable: false,
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      sortable: false,
    },

    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];
  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     dispatch(
  //       qbApiStart({
  //         method: "GET",
  //         entity: "bills",
  //         params: {
  //           //working
  //           // lim: limit * page,
  //           // pg:1,
  //           lim: 1000,
  //         },
  //         // body: {
  //         //
  //         // },
  //       })
  //     );
  //   };
  //   fetchInvoices();
  // }, []);
  const rowData2 = tablerowData?.map((item) => ({
    id: item?.uiid,
    qbSync: item?.qbSync,
    invoiceNumber: item?.invoiceNum || "-",
    businessUnit: "-",
    recordType: "-",
    vendor: item?.vendorId?.businessName || "-",
    employees:
      item?.employeeId
        ?.map((emp) => `${emp.firstName} ${emp.lastName}`)
        .join(", ") || "-",
    invoicDate: dateFormator(item?.invoiceDate, "month-day-year") || "-",
    dueDate: dateFormator(item?.dueDate, "month-day-year") || "-",
    invoiceAmount: item?.amounts?.billed || "-",
    paidAmount: item?.amounts
      ? (item?.amounts?.paid).toString()
      : item?.amounts?.paid || "-",
    syncstatus:
      item?.qbSync?.status === 1
        ? "Not-Synced"
        : item?.qbSync?.status === 2
        ? "Synced"
        : "Partial-Synced",
  }));
  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(rowData2, columns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          //employmentType: { type: "NONE", value: 3 },
          //"isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: false },
        },
        // ret: "uiid invoiceNum employeeId vendorId invoiceDate dueDate amounts addedOn modifiedOn isModified",
        ref: "Employee Vendor",
        // incl: ["firstName lastName", "businessName"],
        incl: ["firstName lastName", ""],
        sort: { [sortConfig.field]: sortConfig.direction },
      })
    );
    dispatch(
      totalCountStart({
        collection: "accountpayables",
        coll: "AccountPayable",
        //filters: item.filters,
      })
    );
  }, [dispatch, page, limit, sortConfig, forceRerenderKey]);

  const forceRerender = () => {
    console.log("F render:::::");
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  const handleQbSync = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);

      return;
    }

    let baseUrl = WORKFORCE_API_URL;

    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;

      const invoiceData = tablerowData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      console.log("invoice data", invoiceData);

      let successCount = 0;

      let failedCount = 0;

      const buildVendorPayload = (data) => ({
        postActions: ["AddQBToVendor"],

        payload: {
          businessName: (data.businessName || "").replace(/[^\w\s]/g, ""),

          uiid: data.uiid || null,

          dbaName: data?.dbaName || "",

          email: data?.email,

          phone: data?.phone,

          website: data?.website,

          generalInfo: {
            locations: data?.generalInfo?.locations,

            recorsStatus: data?.generalInfo.recordStatus,
          },
        },
      });

      const buildAPInvoicePayload = (invoice) => {
        const obj = invoice;

        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),

          uiid: obj?.uiid,

          invoiceNum: obj?.invoiceNum || undefined,

          invoiceBy: obj?.vendorId,

          employeeId: obj?.employeeId?.map((item) => item?.uiid),

          approverId: obj?.approverId,

          vendorId: obj?.vendorId?.uiid,

          //as said incoive date is same a s billed dated

          invoiceDate: obj?.invoiceDate || undefined,

          billedDate: obj?.billedDate || undefined,

          dueDate: obj?.dueDate || undefined,

          netTerms: obj?.netTerms || undefined,

          amounts: obj?.amounts,

          // isModify: true,

          status: obj.status,

          category: obj?.category || undefined,

          type: obj?.type || undefined,

          mailAddress: obj?.mailAddress || undefined,

          contacts: obj?.InvoiceContacts || undefined,

          emails: obj?.emails || undefined,

          invoiceDetails: obj?.invoiceDetails,

          discount:
            obj?.discounts?.map((item) => ({
              name: item?.name || undefined,

              type: item?.type || undefined,

              value: Number(item?.value) || undefined,
            })) || [],

          memo: obj?.memo || undefined,

          comments: obj?.comments || undefined,
        };
      };

      for (const invoice of invoiceData) {
        const vendorData = invoice.vendorId || {};

        const isVendorSynced = Boolean(vendorData?.qbSync?.id);

        if (!isVendorSynced) {
          try {
            const vendorPayload = buildVendorPayload(vendorData);

            await axios.post(`${baseUrl}/qb/vendors`, vendorPayload, {
              headers: { "Content-Type": "application/json" },

              withCredentials: true,
            });
          } catch (err) {
            showToast(
              `${err?.response?.data?.error || "Unknown error"}`,

              "warning",

              5000
            );

            console.error("Vendor Sync Failed:", err.response || err);

            failedCount++;

            continue;
          }
        }

        const isAPInvoiceSynced = Boolean(invoice?.qbSync?.id);

        const invoicePayload = buildAPInvoicePayload(invoice);

        try {
          if (!isAPInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,

              {
                postActions: ["AddQBToAccPay"],

                payload: invoicePayload,
              },

              {
                withCredentials: true,

                headers: { "Content-Type": "application/json" },
              }
            );

            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,

              {
                update: true,

                postActions: ["AddQBToAccPay"],

                payload: invoicePayload,
              },

              {
                withCredentials: true,

                headers: { "Content-Type": "application/json" },
              }
            );
            dispatch(
              updateAccountPayablesStart({
                coll: "AccountPayable",
                uiid: invoicePayload?.uiid,
                qbId: invoicePayload?.qbSync?.id,
                syncFromQB: true,
                supressToast: true,
              })
            );
            successCount++;
          }
        } catch (err) {
          showToast(
            `${err?.response?.data?.error || "Unknown error"}`,

            "warning",

            5000
          );

          console.error("Invoice Sync Error:", err);

          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,

        failedCount > 0 ? "warning" : "success",

        6000
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);

      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);

      forceRerender();
    }
  };

  return (
    <div className="py-8 px-3">
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"QuickBooks - AP Invoices"} tag="h6" />
            </div>
          }
          RightSection={
            <>
              <div className="flex border border-primary-600 gap-2 items-center px-2 rounded-md py-1 cursor-pointer">
                <Avatar
                  src={qbLoading}
                  alt=""
                  outline
                  className="border-none"
                  size="xs"
                />
                <p className="sub-category-meadium font-medium text-primary">
                  Tek Tree LLC
                </p>
              </div>
              <Button
                title="Back"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => window.history.back()}
              />
            </>
          }
        />
      </div>
      <div className="mb-3">
        <PageHeader
          Section={
            <div className="flex">
              <FormFieldSet
                type="search"
                placeholder="invoice No ,Client ,Employee"
                noTitle
              />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Import / Updates"
                size="sm"
                // icon={"arrow_left_alt"}
                onClick={() => handleQbSync("bills")}
                // disabled={true}
              />
            </>
          }
        />
      </div>
      <div>
        <NewTableAdv
          onSelectionChange={(selected) => {
            setSelectedRowIds(selected);
          }}
          columns={columns}
          rows={mappedRows}
          // hideToolBar
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
          showCheckbox
        />
      </div>
      <div>
        {/* <QbDocument isOpen={uploadQb} onClose={() => setUploadQb(false)} /> */}
      </div>
    </div>
  );
};

export default APInvoicesFromQb;
